export interface SearchResult {
  type: 'property' | 'issue' | 'tenancy' | 'prospect'
  id: string
  title: string
  subtitle: string
}

export interface NavItem {
  to: string
  icon: string
  label: string
}

export interface NavGroup {
  label: string
  items: NavItem[]
}

export interface MobileNavItem {
  to: string
  icon: string
  label: string
}

// Base navigation groups (shared between landlord and agent)
export const BASE_NAV_GROUPS: NavGroup[] = [
  {
    label: '',
    items: [
      { to: '/dashboard', icon: '📊', label: 'Dashboard' },
    ],
  },
  {
    label: 'Manage',
    items: [
      { to: '/properties', icon: '🏠', label: 'Properties' },
      { to: '/prospects', icon: '👥', label: 'Prospects' },
      { to: '/viewings', icon: '📅', label: 'Viewings' },
      { to: '/tenants', icon: '🔑', label: 'Tenancies' },
    ],
  },
  {
    label: 'Operations',
    items: [
      { to: '/contractors', icon: '👷', label: 'Contractors' },
      { to: '/maintenance', icon: '🔧', label: 'Maintenance' },
    ],
  },
  {
    label: 'Admin',
    items: [
      { to: '/compliance', icon: '✅', label: 'Compliance' },
      { to: '/financials', icon: '💷', label: 'Financials' },
      { to: '/calendar', icon: '📅', label: 'Calendar' },
      { to: '/activity', icon: '📋', label: 'Activity' },
      { to: '/import', icon: '📥', label: 'Import' },
    ],
  },
]

// Agent-only navigation group
export const AGENCY_NAV_GROUP: NavGroup = {
  label: 'Agency',
  items: [
    { to: '/portfolios', icon: '💼', label: 'Portfolios' },
    { to: '/team', icon: '👥', label: 'Team' },
  ],
}

// Navigation configuration
export const NAV_ITEMS = {
  mobile: [
    { to: '/dashboard', icon: '📊', label: 'Home' },
    { to: '/properties', icon: '🏠', label: 'Properties' },
    { to: '/tenants', icon: '🔑', label: 'Tenancies' },
    { to: '/maintenance', icon: '🔧', label: 'Jobs' },
  ] as MobileNavItem[],
  more: [
    { to: '/financials', icon: '💷', label: 'Financials' },
    { to: '/prospects', icon: '👥', label: 'Prospects' },
    { to: '/viewings', icon: '📅', label: 'Viewings' },
    { to: '/contractors', icon: '👷', label: 'Contractors' },
    { to: '/compliance', icon: '✅', label: 'Compliance' },
    { to: '/calendar', icon: '📅', label: 'Calendar' },
    { to: '/activity', icon: '📋', label: 'Activity' },
    { to: '/earn', icon: '🎁', label: 'Earn Credits' },
  ] as MobileNavItem[],
}
